import { useState } from 'react';

const useUpdateQuota = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const API_URL = process.env.REACT_APP_UPDATE_QUOTA_URL || '';

  const updateQuota = async (
    email: string | undefined,
    updatedQuotaValue: number,
    isGlobal?: boolean
  ): Promise<boolean> => {
    try {
      setLoading(true);
      setError(null);
      const payload = isGlobal
        ? { updated_quota_value: updatedQuotaValue, update_all: true }
        : { email: email, updated_quota_value: updatedQuotaValue };
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const text = await response.text();
        setError(text || `Request failed with status ${response.status}`);
        return false;
      }
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to update quota';
      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { updateQuota, loading, error };
};

export default useUpdateQuota;
